import { styled } from 'react-ui-kit-exante';

export const StyledLayout = styled('div')`
  display: flex;
  background-color: ${({ theme }) => theme?.color?.bg?.basic};
`;
